<template>
    <div :class="{'active': !!show}" class="modal">
        <a href="#close" class="modal-overlay" aria-label="Close" @click.prevent="close"></a>
        <div class="modal-container">
            <transition name="slide" enter-active-class="animated slideInUp" leave-active-class="animated slideOutDown" mode="out-in">
                <div>
                    <div v-if="has_header" class="modal-header">
                        <a href="#close" v-if="closable" class="btn btn-clear" aria-label="Close" @click.prevent="close"></a>
                        <div class="modal-title h5">
                            <slot name="panel-header" :panel="current_panel_id"></slot>
                        </div>
                    </div>
                    <div :style="{'max-height': (maxHeight ? maxHeight : false)}" class="modal-body">
                        <div class="content">
                            <slot name="panel-body" :panel="current_panel_id"></slot>
                        </div>
                    </div>
                    <div v-if="has_footer" class="modal-footer">
                        <slot name="panel-footer" :panel="current_panel_id"></slot>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script type="text/javascript">
export default {
    name: "ModalDialog",
    methods: {
        close () {
            if(this.closable) this.$emit("update:show", false)
        },
        show_panel_id (panel_id) {
            this.$emit("update:current_panel_id", panel_id)
        }
    },
    computed: {
        has_header () {
            return this.closable || (!!this.$slots && !!this.$slots["panel-header"])
        },
        has_footer () {
            return !!this.$slots && !!this.$slots["panel-footer"]
        }
    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
        panel_ids: {
            type: Array,
            default: () => { // panel IDs
                return []
            }
        },
        current_panel_id: {
            type: String,
            default: ""
        },
        maxHeight: {
            type: String,
            default: ""
        },
        closable: {
            type: Boolean,
            default: true
        }
    }
}
</script>
